/* eslint-disable */
import { Box, makeStyles, Typography, Fade, Grow } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import RoundedButton from 'components/Shared/RoundedButton';
import CheckIcon from '@material-ui/icons/Check';
import EmailIcon from '@material-ui/icons/Email';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: theme.shape.borderRadius * 2,
    position: 'relative',
    overflow: 'hidden',
  },
  contentArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.down('xs')]: {},
  },
  successCard: {
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 320,
    maxWidth: 480,
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      minWidth: 280,
      maxWidth: 480,
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 260,
      maxWidth: 480,
      margin: theme.spacing(0, 1),
    },
  },
  iconContainer: {
    position: 'relative',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  iconBox: {
    width: 88,
    height: 88,
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(135deg, ${theme.colors.lightBlue}, ${theme.colors.lightBlue3})`,
    boxShadow: `0 8px 24px ${theme.colors.lightBlue}40, 0 2px 8px rgba(0,0,0,0.1)`,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: 72,
      height: 72,
    },
    [theme.breakpoints.down('xs')]: {
      width: 64,
      height: 64,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: -8,
      left: -8,
      right: -8,
      bottom: -8,
      borderRadius: '50%',
      border: `2px solid ${theme.colors.lightBlue}20`,
      animation: '$pulse 2s infinite',
      [theme.breakpoints.down('xs')]: {
        top: -6,
        left: -6,
        right: -6,
        bottom: -6,
      },
    },
  },
  checkIcon: {
    width: 40,
    height: 40,
    color: theme.palette.common.white,
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))',
    [theme.breakpoints.down('sm')]: {
      width: 32,
      height: 32,
    },
    [theme.breakpoints.down('xs')]: {
      width: 28,
      height: 28,
    },
  },
  emailIconContainer: {
    position: 'absolute',
    bottom: -8,
    right: -8,
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: theme.colors.green,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: `0 4px 12px ${theme.colors.green}40`,
    border: `2px solid ${theme.palette.common.white}`,
    [theme.breakpoints.down('sm')]: {
      width: 28,
      height: 28,
      bottom: -6,
      right: -6,
    },
    [theme.breakpoints.down('xs')]: {
      width: 24,
      height: 24,
      bottom: -5,
      right: -5,
    },
  },
  emailIcon: {
    width: 16,
    height: 16,
    color: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      width: 14,
      height: 14,
    },
    [theme.breakpoints.down('xs')]: {
      width: 12,
      height: 12,
    },
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(1),
    background: `linear-gradient(135deg, ${theme.colors.lightBlue}, ${theme.colors.blue5})`,
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    letterSpacing: '-0.5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
      letterSpacing: '-0.3px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
      letterSpacing: '0px',
    },
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 400,
    textAlign: 'center',
    color: theme.colors.gray4,
    marginBottom: theme.spacing(3),
    lineHeight: 1.5,
    maxWidth: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      marginBottom: theme.spacing(2.5),
      maxWidth: 400,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 13,
      marginBottom: theme.spacing(2),
      maxWidth: 250,
    },
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    backgroundColor: `${theme.colors.lightBlue}08`,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.colors.lightBlue}20`,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1.2),
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2.5),
    },
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
    },
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: 14,
    color: theme.colors.blue2,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
      gap: theme.spacing(0.8),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
      gap: theme.spacing(0.7),
    },
    '& svg': {
      width: 16,
      height: 16,
      color: theme.colors.lightBlue,
      [theme.breakpoints.down('sm')]: {
        width: 14,
        height: 14,
      },
      [theme.breakpoints.down('xs')]: {
        width: 12,
        height: 12,
      },
    },
  },
  actionsContainer: {
    padding: theme.spacing(2, 3, 0, 3),
    borderTop: '1px solid rgba(0, 0, 0, 0.06)',
    flexShrink: 0,
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 2, 0, 2),
    },
  },
  closeButton: {
    width: '100%',
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.shape.borderRadius,
    textTransform: 'none',
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.common.white,
    background: `linear-gradient(135deg, ${theme.colors.lightBlue}, ${theme.colors.lightBlue3})`,
    border: 'none',
    boxShadow: 'none',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      background: `linear-gradient(135deg, ${theme.colors.lightBlue}, ${theme.colors.blue5})`,
      boxShadow: 'none',
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
  '@keyframes pulse': {
    '0%': {
      opacity: 1,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 0.5,
      transform: 'scale(1.05)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
  '@keyframes fadeInUp': {
    from: {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  fadeInUp: {
    animation: '$fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  createButton: {
    textTransform: 'uppercase',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2),
    letterSpacing: 2,
    fontWeight: 'bold',
    fontSize: 13,
    maxHeight: 40,
    minWidth: 120,
  },
}));

const InvitationSent = ({ handleClose, type = 'assessment' }) => {
  const classes = useStyles();
  const { en: { titles, btn } } = useSelector((state) => state.i18n);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 150);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box className={classes.container}>
      <Box className={classes.contentArea}>
        <Fade in={showContent} timeout={600}>
          <Box className={`${classes.successCard} ${classes.fadeInUp}`}>
            <Grow in={showContent} timeout={800}>
              <Box className={classes.iconContainer}>
                <Box className={classes.iconBox}>
                  <CheckIcon className={classes.checkIcon} />
                </Box>
                <Box className={classes.emailIconContainer}>
                  <EmailIcon className={classes.emailIcon} />
                </Box>
              </Box>
            </Grow>

            <Typography className={classes.title}>
              {titles.invitationSent}
            </Typography>

            <Typography className={classes.subtitle}>
              {type === 'assessment'
                ? 'Your assessment invitation has been successfully sent to the patient. They will receive a message with instructions on how to complete their assessment.'
                : 'Your resource invitation has been successfully sent to the patient. They will receive a message with instructions on how to complete their resource.'
              }
            </Typography>

            <Box className={classes.infoSection}>
              <Box className={classes.infoItem}>
                <CheckIcon />
                <span>Patient will receive an immediate notification</span>
              </Box>
              <Box className={classes.infoItem}>
                <CheckIcon />
                <span>{type === 'assessment' ? 'Assessment link is secure and personalized' : 'Resource link is secure and personalized'}</span>
              </Box>
              <Box className={classes.infoItem}>
                <CheckIcon />
                <span>{type === 'assessment' ? 'Results will appear in your dashboard automatically' : 'Access tracking will appear in your dashboard automatically'}</span>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Box>

      <Box className={classes.actionsContainer}>
        <RoundedButton
          variant='contained'
          color='primary'
          size='small'
          onClick={handleClose}
          className={classes.createButton}
        >
          {btn.close}
        </RoundedButton>
      </Box>
    </Box>
  );
};

InvitationSent.propTypes = {
  handleClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['assessment', 'resource']),
};

export default InvitationSent;
